import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./kpit.png"
								alt="kpit"
								className="work-image"
							/>
							<div className="work-title">KPIT Technologies</div>
							<div className="work-subtitle">
								Associate Solution Architect
							</div>
							<div className="work-duration">June-2022 - Present</div>
						</div>

						<div className="work">
							<img
								src="./presto.png"
								alt="presto"
								className="work-image"
							/>
							<div className="work-title">Presto Inc (Product company)</div>
							<div className="work-subtitle">
								Lead Engineer
							</div>
							<div className="work-duration">Feb-2021 - May-2022</div>
						</div>

						<div className="work">
							<img
								src="./tcs.png"
								alt="tcs"
								className="work-image"
							/>
							<div className="work-title">Tata Consultancy Services</div>
							<div className="work-subtitle">
								Lead Engineer
							</div>
							<div className="work-duration">Feb-2016 - Feb-2021</div>
						</div>
						<div className="work">
							<img
								src="./qburst.png"
								alt="qburst"
								className="work-image"
							/>
							<div className="work-title">QBurst Technologies</div>
							<div className="work-subtitle">
								Android Developer
							</div>
							<div className="work-duration">Oct-2011 - Dec-2016</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
